import { useEffect } from 'react';

import { Banner, Box, Text } from '@betterment/samba-react';
import { useLocation } from 'react-router-dom';

import { useNotifications } from './useNotifications';

import type { Notification } from './types';
import type { SystemStyleObject } from '@betterment/samba-styled-system/types';

type Props = {
  css?: SystemStyleObject;
};

type NotificationBannerProps = {
  notification: Notification;
  dismissNotification: (id: string) => void;
};

function NotificationBanner({ notification, dismissNotification }: NotificationBannerProps) {
  const { id, type, message, isDismissable } = notification;

  useEffect(() => () => dismissNotification(id), [id, dismissNotification]);

  return (
    <Banner variant={type} role="status">
      <Banner.Content>
        <Text>{message}</Text>
      </Banner.Content>
      {isDismissable && <Banner.Close onClick={() => dismissNotification(id)} />}
    </Banner>
  );
}
export function Notifications({ css: cssProp }: Props) {
  const location = useLocation();
  const { notifications, dismissNotification, flushNotifications } = useNotifications();

  useEffect(() => {
    flushNotifications();
  }, [location, flushNotifications]);

  if (!notifications.length) {
    return null;
  }

  return (
    <Box
      data-testid="notifications"
      css={{
        display: 'grid',
        gap: 'space.200',
        ...cssProp,
      }}
    >
      {notifications.map(notification => (
        <NotificationBanner
          key={notification.id}
          notification={notification}
          dismissNotification={dismissNotification}
        />
      ))}
    </Box>
  );
}
